import SplitHero from '@/components/feature/SplitHero';
import Container from '@/components/feature/Container';
import NumberedSteps from '@/components/feature/NumberedSteps';
import FaqList from '@/components/feature/FaqList';
import Reveal from '@/components/base/Reveal';
import Eyebrow from '@/components/base/Eyebrow';
import PillLink from '@/components/base/PillLink';
import EnquiryForm from './components/EnquiryForm';
import { visitFaqs } from '@/mocks/care';

export default function Visit() {
  return (
    <>
      <SplitHero
        eyebrow="Visit & Contact"
        title={<>Come and see <span className="em-serif">for yourself.</span></>}
        intro="Pop in for a cup of tea, meet the people who make each day here, and ask anything you like. No pressure, just an honest conversation."
        img="https://public.readdy.ai/ai/img_res/sandbox/d9f57693db1a3f647bcb80a40a4edde0/5fa7b452-069c-4ae4-8f43-36e8851e8c88_dw-v-hero.webp"
        alt="Mother and daughter sharing tea during a visit"
      />

      <section className="py-16 md:py-24 bg-background-100">
        <Container>
          <Reveal>
            <Eyebrow>What to Expect</Eyebrow>
            <h2 className="mt-5 mb-12 md:mb-16 text-[32px] md:text-[46px] leading-[1.08] font-medium tracking-[-0.02em]">Simple, unhurried, <span className="em-serif">personal.</span></h2>
          </Reveal>
          <NumberedSteps
            steps={[
              { t: 'Tell us what matters', d: 'Share a little about your loved one, their routines and what you hope to find.' },
              { t: 'Explore the possibilities', d: 'We\u2019ll talk through the kinds of support that could fit, openly and honestly.' },
              { t: 'Arrange your visit', d: 'Choose a time that suits and come and see everyday life for yourself.' },
            ]}
          />
        </Container>
      </section>

      <section id="enquiry" className="py-16 md:py-28 scroll-mt-20">
        <Container className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <Reveal className="lg:col-span-4">
            <Eyebrow>Enquiry</Eyebrow>
            <h2 className="mt-5 text-[32px] md:text-[46px] leading-[1.08] font-medium tracking-[-0.02em]">Let&rsquo;s start a <span className="em-serif">conversation.</span></h2>
            <p className="mt-6 text-[16px] leading-relaxed text-foreground-700 max-w-sm">Send us a few details and we&rsquo;ll get back to you to arrange a visit or a chat at a time that works for you.</p>
          </Reveal>
          <Reveal className="lg:col-span-8" delay={100}>
            <div className="rounded-2xl bg-background-100 border border-background-200 p-5 sm:p-8 md:p-10">
              <EnquiryForm />
            </div>
          </Reveal>
        </Container>
      </section>

      <section className="pb-16 md:pb-28">
        <Container className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <Reveal className="lg:col-span-4">
            <Eyebrow>FAQ</Eyebrow>
            <h2 className="mt-5 text-[30px] md:text-[40px] leading-[1.08] font-medium tracking-[-0.02em]">Before you <span className="em-serif">visit.</span></h2>
          </Reveal>
          <div className="lg:col-span-8"><FaqList items={visitFaqs} idPrefix="visit-faq" /></div>
        </Container>
      </section>

      <section className="pb-16 md:pb-28">
        <Container>
          <Reveal>
            <div className="rounded-2xl md:rounded-[20px] bg-primary-500 text-background-50 px-6 py-16 md:px-16 md:py-24 flex flex-col md:flex-row md:items-end justify-between gap-8">
              <h2 className="text-[34px] md:text-[56px] leading-[1.05] font-medium tracking-[-0.02em] max-w-xl">Here whenever you&rsquo;re <span className="em-serif">ready.</span></h2>
              <PillLink to="/visit#enquiry" variant="light">Send an Enquiry</PillLink>
            </div>
          </Reveal>
        </Container>
      </section>
    </>
  );
}